var exports = {
  "k": "x4c3adb35--3060be--container",
};

module.exports = exports;
